import { motion } from "framer-motion";
import { Heart } from "lucide-react";

const petals = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  left: Math.random() * 100,
  delay: Math.random() * 12,
  duration: 18 + Math.random() * 14,
  size: 10 + Math.random() * 16,
  opacity: 0.18 + Math.random() * 0.28,
  drift: (Math.random() - 0.5) * 80,
}));

export const FloatingHearts = () => {
  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-0" aria-hidden>
      {petals.map((p) => (
        <motion.div
          key={p.id}
          initial={{ y: "110vh", x: 0, rotate: 0, opacity: 0 }}
          animate={{
            y: "-15vh",
            x: [0, p.drift, -p.drift, 0],
            rotate: [0, 25, -20, 15, 0],
            opacity: [0, p.opacity, p.opacity, 0],
          }}
          transition={{
            duration: p.duration,
            delay: p.delay,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{ left: `${p.left}%`, width: p.size, height: p.size }}
          className="absolute text-rose-300"
        >
          <Heart
            className="w-full h-full"
            strokeWidth={1.25}
            fill="currentColor"
          />
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingHearts;
